import { render, staticRenderFns } from "./AllocateUserForm.vue?vue&type=template&id=378d059b"
import script from "./AllocateUserForm.vue?vue&type=script&lang=js"
export * from "./AllocateUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports